import { trigger, animate, transition, style, animation, useAnimation } from '@angular/animations';

// Fade In Animation
const fadeInAnimation = animation([
  style({ opacity: 0 }),
  animate('{{ duration }}ms ease-in-out', style({ opacity: 1 })),
]);

export const fadeInTransition = trigger('fadeInTransition', [
  transition(':enter', useAnimation(fadeInAnimation, { params: { duration: 1000 } })),
]);

// Fade Out Animation
const fadeOutAnimation = animation([animate('{{ duration }}ms ease-in-out', style({ opacity: 0 }))]);

export const fadeOutTransition = trigger('fadeOutTransition', [
  transition(':leave', [
    useAnimation(fadeOutAnimation, { params: { duration: 1500 } }),
    style({ visibility: 'hidden' }),
  ]),
]);
